export default "__VITE_ASSET__0A45zttE__"